import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface UseReportTrackingProps {
  reportToken: string | null;
  quizSubmissionId?: string | null;
  leadSubmissionId?: string | null;
}

export const useReportTracking = ({
  reportToken,
  quizSubmissionId,
  leadSubmissionId
}: UseReportTrackingProps) => {
  useEffect(() => {
    const trackReportView = async () => {
      if (!reportToken) return;

      try {
        // Check if user is admin
        const { data: { session } } = await supabase.auth.getSession();
        let isAdmin = false;

        if (session) {
          const { data: roles } = await supabase
            .from('user_roles')
            .select('role')
            .eq('user_id', session.user.id)
            .eq('role', 'admin')
            .single();

          isAdmin = !!roles;
        }

        // Track the view
        const { error } = await supabase
          .from('report_views')
          .insert({
            report_token: reportToken,
            quiz_submission_id: quizSubmissionId || null,
            lead_submission_id: leadSubmissionId || null,
            user_agent: navigator.userAgent,
            is_admin: isAdmin
          });

        if (error) {
          console.error('Error tracking report view:', error);
        } else {
          console.log('📊 Report view tracked:', { reportToken, isAdmin });
        }
      } catch (error) {
        console.error('Error in report tracking:', error);
      }
    };

    trackReportView();
  }, [reportToken, quizSubmissionId, leadSubmissionId]);
};
